//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import mixin from './mixin.js';

export default {
  name: 'FeedbackCarousel',
  mixins: [mixin],
  props: { carouselItem: { type: Array, default: () => [] } },
  computed: {
    fullItems() {
      const items = this.carouselItem;
      const length = items.length;

      // 項目長度等於1時不輪播, 等於2時複製一份(大於3)輪播
      if (length === 2) {
        return items.concat(items);
      }

      return items;
    },
  },
  methods: {
    clickItem(id, index) {
      if (index === this.activeIndex) this.$emit('click', id);
    },
  },
};
